/* automatically generated by proto-to-cli */
import { toInt, toFloat, toFile, toBoolean, HandleRepeated } from "proto-to-cli/dist/parser.js";
import { Command } from 'commander';
const run = new Command("run");
run.requiredOption('-i,--input <bytes>',"ttf/woff2 文件的 buffer",toFile)
    .option('-o,--outDir <string>',"切割后放置文件的文件夹")
    .option('--css.fontFamily <string>',"字体家族名称")
    .option('--css.fontWeight <string>',"字体粗细")
    .option('--css.fontStyle <string>',"字体样式")
    .option('--css.fontDisplay <string>',"字体显示方式")
    .option('--css.localFamily <string>',"本地字体家族名称")
    .option('--polyfill.name <string>',"名称")
    .option('--polyfill.format <string>',"格式")
    .option('--css.commentBase <bool>',"基础注释",toBoolean)
    .option('--css.commentNameTable <bool>',"名称表注释",toBoolean)
    .option('--css.commentUnicodes <bool>',"Unicode 注释",toBoolean)
    .option('--css.compress <bool>',"是否压缩",toBoolean)
    .option('--css.fileName <string>',"文件名")
    .option('-t,--targetType <string>',"目标类型")
    .option('-s,--subsets <bytes>',"子集",HandleRepeated(toFile))
    .option('-c,--chunkSize <int32>',"包大小",toInt)
    .option('--chunkSizeTolerance <float>',"包大小容差",toFloat)
    .option('-m,--maxAllowSubsetsCount <int32>',"最大允许子集数量",toInt)
    .option('--testHtml <bool>',"是否生成测试 HTML",toBoolean)
    .option('-r,--reporter <bool>',"是否生成 reporter.bin",toBoolean)
    .option('--previewImage.text <string>',"会显示在 svg 中的文本")
    .option('--previewImage.name <string>',"svg 文件的名称")
    .option('--renameOutputFont <string>',"重命名输出字体")
    .option('-b,--buildMode <string>',"TODO 构建模式")
    .option('-l,--languageAreas <bool>',"是否进行语言区域优化",toBoolean)
    .option('--multiThreads <bool>',"TODO 是否使用多线程",toBoolean)
    .option('-f,--fontFeature <bool>',"是否启用字体特性",toBoolean)
    .option('--reduceMins <bool>',"是否减少最小分包，",toBoolean)
    .option('-a,--autoSubset <bool>',"是否自动子集化",toBoolean)
    .option('--subsetRemainChars <bool>',"是否自动添加没有声明的字符",toBoolean)
export const getCliParams = (argv: string[], extraFn?: (cm: Command, run: Command) => void) => {
    const program = new Command();
    program.addCommand(run, { isDefault: true });
    extraFn && extraFn(program, run);
    return program.parse(argv);
};